var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11513_27934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 10V18.3333H3.33301V10",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 5.83398H1.66699V10.0007H18.3337V5.83398Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.334V5.83398",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5.83268H6.25033C5.69779 5.83268 5.16789 5.61319 4.77719 5.22249C4.38649 4.83179 4.16699 4.30188 4.16699 3.74935C4.16699 3.19681 4.38649 2.66691 4.77719 2.27621C5.16789 1.88551 5.69779 1.66602 6.25033 1.66602C9.16699 1.66602 10.0003 5.83268 10.0003 5.83268Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83268H13.75C14.3025 5.83268 14.8324 5.61319 15.2231 5.22249C15.6138 4.83179 15.8333 4.30188 15.8333 3.74935C15.8333 3.19681 15.6138 2.66691 15.2231 2.27621C14.8324 1.88551 14.3025 1.66602 13.75 1.66602C10.8333 1.66602 10 5.83268 10 5.83268Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.a2703c55111547d77ab5941a98ef6202.svg";
export { ForwardRef as ReactComponent };